import { Box, Typography } from '@mui/material';
import { AppStoreButtons } from './AppStoreButtons';

export const CTASection = () => {
  return (
    <Box
      sx={{
        textAlign: 'center',
        mt: { xs: 6, md: 8 },
        py: { xs: 6, md: 8 },
        px: 3,
        backgroundColor: 'background.paper',
        borderRadius: 4,
        border: '1px solid',
        borderColor: 'grey.200',
      }}
    >
      <Typography
        variant="h2"
        sx={{
          mb: 2,
        }}
      >
        Ready to Start?
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{
          mb: 4,
          maxWidth: '500px',
          mx: 'auto',
        }}
      >
        Join thousands of users who have transformed their relationship with
        food and nutrition.
      </Typography>
      <AppStoreButtons />
    </Box>
  );
};
